<template>
  <el-dialog class="el-dialogs" :title="title" width="600px" :close-on-click-modal="false"
             :visible.sync="visible">
    <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
             label-width="110px">
      <div class="p_all1 Selected">
        已选择 <span>{{ dataListSelect.length }}</span> 项资源
      </div>
      <el-form-item label="发布方式：" prop="releaseMethod">
        <el-radio-group v-model="searchForm.releaseMethod" @input="changeMethod">
          <el-radio label="0">即时发布</el-radio>
          <el-radio label="1">定时发布</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="searchForm.releaseMethod == 1" label="发布时间：" prop="releaseDate">
        <el-date-picker
            v-model="searchForm.releaseDate"
            type="datetime"
            style="width: 100%"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发布渠道：" prop="channelId">
        <el-select style="width: 100%" v-model="searchForm.channelId" multiple
                   clearable @change="selectChanne"
                   placeholder="请选择发布渠道">
          <el-option
              v-for="item in releaseChannelList"
              :key="item.id"
              :label="item.channelName"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布栏目：" prop="columnManagementId">
        <el-select style="width: 100%" v-model="searchForm.columnManagementId"
                   clearable multiple
                   placeholder="请选择发布栏目">
          <el-option
              v-for="item in releaseColumnlList"
              :key="item.id"
              :label="item.column_management_name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布顺序：" prop="publishSequence">
        <el-input v-model.trim="searchForm.publishSequence"
                  :placeholder='`请输入发布顺序(1~${maxIndex})`' @input="setBorrowDays('publishSequence')"
                  clearable></el-input>
      </el-form-item>
      <el-form-item label="发布字段：" prop="publishField">
        <el-button type="primary" size="mini" @click="selectMetadata()">选择元数据</el-button>
        <div class="fieldCont">
          <el-tag v-for="(item) in searchForm.publishField" :key="item.basicCode">{{ item.basicRename }}</el-tag>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" type="primary" @click="submit()" v-noMoreClick>发布</el-button>
    </div>
    <select-metadata ref="selectMetadata" @selectData="selectData"></select-metadata>
  </el-dialog>
</template>

<script>
import SelectMetadata from "@/components/release/selectMetadata.vue";

export default {
  name: "release",
  components: {SelectMetadata},
  data() {
    return {
      title: '资源发布',
      visible: false,
      searchForm: {
        releaseMethod: '0',
        releaseDate: '',
        channelId: [],
        columnManagementId: [],
        publishSequence: '',
        publishField: [],
      },
      rules: {
        releaseMethod: [
          {required: true, message: '请选择发布方式', trigger: 'change'}
        ],
        releaseDate: [
          {required: true, message: '请选择发布时间', trigger: 'change'}
        ],
        channelId: [
          {type: 'array', required: true, message: '请选择发布渠道', trigger: 'change'}
        ],
        publishField: [
          {type: 'array', required: true, message: '请选择发布字段', trigger: 'change'}
        ],
      },
      releaseChannelList: [],
      releaseColumnlList: [],

      menuId: '',
      basicDataId: '',
      dataListSelect: [],

      maxIndex: '0',
    }
  },

  methods: {
    // basicDataId模板id  dataListSelect 列表选择的数据 metadataFonctionsModelDetailId按钮id
    init(basicDataId, dataListSelect, metadataFonctionsModelDetailId) {
      this.menuId = this.$route.meta.menuId
      this.visible = true
      this.basicDataId = basicDataId
      this.metadataFonctionsModelDetailId = metadataFonctionsModelDetailId
      this.dataListSelect = dataListSelect.map(item => {
        return item.id
      })
      this.releaseColumnlList = []
      this.$nextTick(() => {
        this.$refs.searchForm.resetFields()
      })
      this.getOthers()
    },

    getOthers() {
      this.$axios(this.api.dyygRelease.releasesChannelSelectAll, {
        flag: 0,
      }).then(data => {
        if (data && data.status) {
          this.releaseChannelList = data.data
        }
      })

      this.$axios(this.api.user.configKey + 'publish_sequence').then(data => {
        if (data && data.status) {
          this.maxIndex = data.data
        }
      })
    },

    //选择渠道
    selectChanne() {
      this.searchForm.columnManagementId = ''
      this.$axios(this.api.dyygRelease.getByChannelIds, this.searchForm.channelId, 'post').then(data => {
        if (data && data.status) {
          this.releaseColumnlList = data.data
        }
      })
    },

    changeMethod() {
      if (this.searchForm.releaseMethod == '0') {
        this.searchForm.releaseDate = ''
      }
    },

    //只能输入大于0的正整数
    setBorrowDays(formName) {
      this.searchForm[formName] = this.searchForm[formName].replace(/[^0-9]/g, "")
      if (this.searchForm[formName] == 0) {
        this.searchForm[formName] = ''
      }
      if (this.searchForm[formName] > this.maxIndex) {
        this.searchForm[formName] = this.maxIndex
      }
    },

    //选择元数据
    selectMetadata() {
      this.$refs.selectMetadata.init(this.basicDataId, this.searchForm.publishField)
    },

    //选中的数据
    selectData(seList) {
      this.searchForm.publishField = seList
    },

    submit() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.$confirm(`审核通过后，所选资源支持在发布渠道中查看，是否继续?`, '确定提交发布信息？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let releaseData = JSON.parse(JSON.stringify(this.searchForm))
            let channelName = []
            this.releaseChannelList.forEach(item => {
              this.searchForm.channelId.forEach(item2 => {
                if (item.id == item2) {
                  channelName.push(item.channelName)
                }
              })
            })
            channelName = channelName.join(',')
            releaseData.publishField = releaseData.publishField.map(item => {
              return item.basicCode
            }).join(',')
            releaseData.channelId = releaseData.channelId.join(',')
            if (releaseData.columnManagementId) {
              releaseData.columnManagementId = releaseData.columnManagementId?.join(',')
            }
            this.$axios(this.api.metadata.metadataPublishSave, {
              menuId: this.menuId,
              configId: this.$route.query.id,
              channelName,
              metadataPublish: releaseData,
              dataIds: this.dataListSelect,
              metadataFonctionsModelDetailId: this.metadataFonctionsModelDetailId,
            }, 'post').then(data => {
              if (data && data.status) {
                this.$message.success(`发布成功`)
                this.$emit('refresh')
                this.visible = false
              } else {
                this.$message.error(data.msg)
              }
            })
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.fieldCont {
  margin-top: 10px;
  max-height: 150px;
  overflow-y: auto;
}
</style>